import Spinner from "../../organisms/Spinner";
import { SPINNER_NAMES } from "../../organisms/Spinner/spinner.constants";

const { LOADING_PAGE } = SPINNER_NAMES;

const LoadingPage = ({ title, subtitle }) => {

  return (
    <>
      <div className="flex content m-auto place-items-center">
        <div className="text-center p-6 justify-center">
          <div>
            <Spinner name={LOADING_PAGE} />
          </div>
          <span className="text-3xl font-bold text-white mb-4">{title}</span>
          <p className="text-base text-gray-200 mb-6">{subtitle}</p>
        </div>
      </div>
    </>
  );
};
export default LoadingPage;
